import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import HeroCarousel from '../../containers/hero-carousel';

import HeroVideo from '../../blocks/hero-video';
import HeroImage from '../../blocks/hero-image';
import PhotoInfo from '../../containers/photo-info';
import RelatedVideo from '../../containers/related-video';

const HeroCarouselBlock = props => <HeroCarousel {...props} />;
HeroCarouselBlock.displayName = 'HeroCarousel';

export default withDynamicComponents({
  componentWhitelist: [
    HeroVideo,
    HeroImage,
    RelatedVideo,
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['components', 'children'],
  ],
})(HeroCarouselBlock);



// WEBPACK FOOTER //
// ./src/blocks/hero-carousel/index.jsx